import { render, staticRenderFns } from "./Infos.vue?vue&type=template&id=cca2045e&scoped=true"
import script from "./Infos.ts?vue&type=script&lang=ts&external"
export * from "./Infos.ts?vue&type=script&lang=ts&external"
import style0 from "./Infos.vue?vue&type=style&index=0&id=cca2045e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca2045e",
  null
  
)

export default component.exports